<template>
  <div class="tag">
    {{ tag.label }} <span class="tag__remove icon-cross" @click="removeFilter"></span>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Tags',
  props: {
    tag: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    ...mapActions({
      removeSecondaryFilter: 'filter/removeSecondaryFilter',
    }),

    removeFilter() {
      this.removeSecondaryFilter(this.tag)
    },
  },
}
</script>

<style lang="scss" scoped>
@import './Tag';
</style>
